// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form___3WN5I","form-input":"styles__form-input___2N5Rc","form-textarea":"styles__form-textarea___2dduY","inputWrapper":"styles__inputWrapper___23jwU","inputLabel":"styles__inputLabel___3z3SW","inputElement":"styles__inputElement___24xsy","button":"styles__button___Uhr5A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/formElement/styles.css
// module id = 674
// module chunks = 0